/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import PDFMerger from 'pdf-merger-js';
import printJS from 'print-js-updated';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Dropdown } from 'react-bootstrap';
import Checkbox from '@material-ui/core/Checkbox';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import _ from 'lodash';
// import custom Component
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import * as AppConstants from '../../../../SharedModules/AppConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import CheckBoxRender from './gridComponents/CheckBoxRender';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
// Import custom function
import {
  tableGridHight350,
  beginPrintingOptionList,
  remotePrinterOptions,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import {
  setSelectManufacturerData,
  fetchAllManufacturerDetail,
  getContactDetails,
  maintainLabelerListData,
  setMaintainManufacturerTab,
} from '../../../Maintain/Manufacturer/store/ManufacturerAction';
import {
  selectedType,
  dispatchCellClick,
} from '../../../Maintain/Contract/store/actions';
import { getRebatePgmDetail } from '../../../Maintain/RebateProgram/SearchRebate/store/actions';
import {
  getCheckPay,
  getDefaultAuditValues,
} from '../../../Maintain/RebateProgram/store/actions';
import {
  redirectURLLink,
  handleScrollToEvent,
  convertPDFURLFromAPI,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  getSearchGenerateInvByCriteriaList,
  getPlanTypeCdUsingRebateProg,
  getResumeInvoicePrintList,
  dispatchGenerateInvoiceCriteriaList,
  setPdfInvoice,
  setGenerateInvoiceDetailTab,
  dispatchUpdateCustomizeLetter,
  postUpdateCustomizeLetter,
  callRunApi,
  getPrintPreview,
  saveFailedInvoice,
  remotePrintInvoice,
} from '../store/Actions';
import { GenerateInvoiceTableHead } from './gridComponents/tableHead';
import * as blankPDF from './base64BlankPDF';
import {
  getInvoiceDetailsByInvoiceNum,
  getInvoiceLetterTableData,
  getPrintCover,
} from '../../../Display/InvoiceReport/store/actions';


function GenerateInvoiceDetailsCom() {
  const dispatch = useDispatch();
  const history = useHistory();
  // use Selector function
  const detailScreenTabData = useSelector(
    (state) => state.sharedState.GenerateInvoiceReducer?.generateInvDetailTabObj
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const fetchState = useSelector(
    (state) =>
      state.sharedState.GenerateInvoiceReducer?.perviousSearchScreenDataRedux
        ?.state
  );
  const generateInvoiceGridData = useSelector((state) =>
    state.sharedState.GenerateInvoiceReducer?.generateInvoiceGridVOList?.sort(
      (a, b) => a.cfSortKey - b.cfSortKey
    )
  );
  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const rebateProgramDetailData = useSelector(
    (state) => state?.sharedState?.SearchRebateReducer?.pgm_res
  );
  const defaultSystemAudit = useSelector(
    (state) => state?.sharedState?.RebatePgmReducer?.def_sys_aud
  );
  const unitType = useSelector(
    (state) => state?.sharedState?.RebatePgmReducer?.unit_type
  );
  const runApiResult = useSelector(
    (state) => state.sharedState.GenerateInvoiceReducer?.runApiResult
  );
  const pdfPrev = useSelector(
    (state) => state.sharedState.GenerateInvoiceReducer?.pdfPrev
  );
  const searchScreenTabObj = useSelector(
    (reduxState) =>
      reduxState.sharedState.GenerateInvoiceReducer?.generateInvoiceTabObj
  );
  const customizeLetterMessage = useSelector((state) => {
    return state.sharedState.GenerateInvoiceReducer?.customizeLetterMsg;
  });
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const fetchPlanTypeCd = useSelector((state) => {
    return state.sharedState.GenerateInvoiceReducer?.planTypeCd;
  });
  const invoiceDetailsByInvoiceNum = useSelector(
    (state) => state.sharedState.InvoiceReportReducer.invoiceDetailsByInvoiceNum
  );
  // variable deceleration
  const gridRef = React.useRef();
  const [redirectionState, setRedirection] = useState(false)
  const [openBeginPrinting, setOpenBeginPrinting] = useState(false);
  const [customizeLetterPopup, setCustomizeLetterPopup] = useState(false);
  const [runLaterPopup, setRunLaterPopup] = useState(false);
  const [showPrinterOption, setShowPrinterOption] = useState(false);
  const [selectPrinterOption, setSelectPrinterOption] =
    useState('localPrinting');
  const [remotePrinterIpAddrList, setRemotePrinterIpAddrList] = useState([]);
  const [selectedRemotePrinterIp, setSelectedRemotePrinterIp] = useState('');
  const [callRedirectRebateProgram, setCallRedirectRebateProgram] =
    useState(false);
  const [progressBarPopup, setProgressBarPopup] = useState(false);
  const [warningAlert, setWarningAlert] = useState(false);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [warningMessage, setWaringMessage] = useState('');
  const [freeFromTextValue, setFreeFromTextValue] = useState('');
  const [errorMessages, setErrorMessages] = useState(null);
  const [invoiceNum, setInvoiceNum] = useState(null);
  const [gridParams, setGridParams] = useState(null);
  const [columnDefs, setColumnDefs] = useState([]);
  const [beginPrintingState, setBeginPrintingState] = useState('both');
  const [redirect, setRedirect] = useState(false);
  const [runButton, setRunButton] = useState('');
  const [state, setState] = useState(
    detailScreenTabData?.state
      ? detailScreenTabData.state
      : {
          includeCreated: 0,
          includeNonRequested: 0,
          includeUploaded: 0,
          includePrinted: 1,
          includeMailed: 0,
          includeNotCreated: 0,
          actionType: 0,
        }
  );

  React.useEffect(() => {
    if (process.env.REACT_APP_PRINTER_IP_ADDRESS) {
      const list = process.env.REACT_APP_PRINTER_IP_ADDRESS?.split(',');
      if (list?.length > 0) {
        setRemotePrinterIpAddrList(
          list.map((prop) => ({
            value: prop.trim(),
            label: prop.trim(),
          }))
        );
      }
    }
  }, []);

  React.useEffect(() => {
    if (!showPrinterOption) {
      return;
    }
    const defaultIp = UserDefaultValues?.printerIpAddrs;
    if (defaultIp && defaultIp !== '-1') {
      setSelectedRemotePrinterIp(defaultIp);
    } else if (remotePrinterIpAddrList?.length > 0) {
      setSelectedRemotePrinterIp(remotePrinterIpAddrList[0].value);
    } else {
      setSelectedRemotePrinterIp('');
    }
  }, [
    showPrinterOption,
    UserDefaultValues?.printerIpAddrs,
    remotePrinterIpAddrList,
  ]);

  const handlePrinterOptionChange = (optionValue) => {
    setSelectPrinterOption(optionValue);
    if (optionValue === 'remotePrinting') {
      const defaultIp = UserDefaultValues?.printerIpAddrs;
      if (defaultIp && defaultIp !== '-1') {
        setSelectedRemotePrinterIp(defaultIp);
      } else if (remotePrinterIpAddrList?.length > 0) {
        setSelectedRemotePrinterIp(remotePrinterIpAddrList[0].value);
      }
    }
  };

  // handling onPage load call service
  React.useEffect(() => {
    if (generateInvoiceGridData?.length == 0) {
      handleScrollToEvent();
      dispatch(
        setGenerateInvoiceDetailTab({
          ...detailScreenTabData,
          errorMessages: [constantMessageData.MNFC_NDC_ERROR_MSG],
          successMessages: [],
        })
      );
    }
    handleScrollToEvent();
    setWarningAlert(false);
    setColumnDefs(GenerateInvoiceTableHead);
    dispatch(setPdfInvoice(null));
    if (!defaultSystemAudit) dispatch(getDefaultAuditValues());
    if (!unitType) dispatch(getCheckPay('UNIT_TYPE_CD'));
  }, []);

  // handing highlight tab
  React.useEffect(() => {
    if (detailScreenTabData?.errorMessages?.length > 0) {
      tabHighLigther('/generateInvoiceDetail', true);
    } else {
      tabHighLigther('/generateInvoiceDetail', false);
    }
  }, [JSON.stringify(detailScreenTabData)]);

  // handle pdf url
  // React.useEffect(() => {
  //   if (pdfPrev && pdfPrev !== 'failed') {
  //     const purl = convertPDFURLFromAPI(pdfPrev);
  //     if (purl) {
  //       if (state?.actionType === 0) {
  //         dispatch(
  //           setGenerateInvoiceDetailTab({
  //             ...detailScreenTabData,
  //             successMessages: [AppConstants.INVOICE_JOB_COMPLETE],
  //             errorMessages: [],
  //           })
  //         );
  //       }
  //       window.open(purl);
  //       dispatch(setPdfInvoice(null));
  //     }
  //   } else if (pdfPrev === 'failed') {
  //     handleScrollToEvent();
  //     dispatch(setPdfInvoice(null));
  //     dispatch(
  //       setGenerateInvoiceDetailTab({
  //         ...detailScreenTabData,
  //         errorMessages: [constantMessageData.FAIL_PROCESSING_REQUEST],
  //         successMessages: [],
  //       })
  //     );
  //   }
  // }, [pdfPrev]);
  // set Initial state values
  React.useEffect(() => {
    if (Object.keys(detailScreenTabData)?.length === 0) {
    } else {
      const tempObj = detailScreenTabData;
      if (tempObj?.fullScreenView) setFullScreenView(tempObj.fullScreenView);
      if (tempObj.callRedirectRebateProgram)
        setCallRedirectRebateProgram(tempObj.callRedirectRebateProgram);
      if (tempObj.runButton) setRunButton(tempObj.runButton);
      if (tempObj.freeFromTextValue)
        setFreeFromTextValue(tempObj.freeFromTextValue);
    }
  }, [detailScreenTabData]);
  React.useEffect(() => {
    if (
      redirect &&
      invoiceDetailsByInvoiceNum &&
      Object.keys(invoiceDetailsByInvoiceNum).length > 0
    ) {
      setRedirect(false);
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: '/invoice-report-details',
        value: 'Invoice Report Details',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      history.push({
        pathname: '/invoice-report-details',
        invoiceDetailsByInvoiceNum: invoiceDetailsByInvoiceNum.data,
      });
    }
  }, [invoiceDetailsByInvoiceNum]);

  // click on filter icon after call
  const handleClearFilter = () => {
    if (gridRef !== null) {
      if (gridRef?.current) gridRef.current.clearFilters();
      if (gridParams?.columnApi && gridParams?.columnApi !== null) {
        gridParams.columnApi.applyColumnState({
          state: [{ colId: 'cfSortKey', sort: 'asc' }],
        });
      }
    }
  };
  // handing by default 1st row selection function
  const onGridReady = (params) => {
    setGridParams(params);
  };
  // handing  full screen view function
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    dispatch(
      setGenerateInvoiceDetailTab({
        ...detailScreenTabData,
        fullScreenView: !fullScreenView,
      })
    );
  };
  // handle click on Clear All button after calling APi service
  const handleRedirectInvoiceDetailScreen = (generateInvoiceDetail) => {
    handleClearFilter();
    dispatch(
      getSearchGenerateInvByCriteriaList({
        rebateProgramCd: fetchState?.rebateProgramCd,
        qtr: fetchState?.quarterValue,
        planTypeCd: fetchState?.planTypeCd,
        includeCreated: generateInvoiceDetail?.includeCreated,
        includeNonRequested: generateInvoiceDetail?.includeNonRequested,
        includeUploaded: generateInvoiceDetail?.includeUploaded,
        includePrinted: generateInvoiceDetail?.includePrinted,
        includeMailed: generateInvoiceDetail?.includeMailed,
        includeNotCreated: generateInvoiceDetail?.includeNotCreated,
        action: generateInvoiceDetail?.actionType,
      })
    );
  };
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  // handle Run Now and Run later response after call
  React.useEffect(() => {
    if (runApiResult && runApiResult.status === '001') {
      if (runButton === 'N') {
        if (state?.actionType !== 0) {
          dispatch(
            setGenerateInvoiceDetailTab({
              ...detailScreenTabData,
              successMessages: [AppConstants.INVOICE_JOB_COMPLETE],
              errorMessages: [],
            })
          );
        }
        dispatch(dispatchGenerateInvoiceCriteriaList([]));
        if (fetchState?.isResumePrinting) {
          dispatch(
            getResumeInvoicePrintList({
              userId: UserDefaultValues?.userId
                ? UserDefaultValues?.userId
                : logInUser,
            })
          );
        } else {
          handleRedirectInvoiceDetailScreen({ ...state });
        }
        handleScrollToEvent();
      } else if (runButton === 'L') {
        handleScrollToEvent();
        dispatch(
          setGenerateInvoiceDetailTab({
            ...detailScreenTabData,
            successMessages: [constantMessageData.RUN_LATER_MESSAGE],
            errorMessages: [],
          })
        );
        dispatch(dispatchGenerateInvoiceCriteriaList([]));
        handleRedirectInvoiceDetailScreen({ ...state });
      }
    } else if (runApiResult && runApiResult?.status === '003') {
      dispatch(
        setGenerateInvoiceDetailTab({
          ...detailScreenTabData,
          successMessages: [],
          errorMessages: [
            runApiResult?.message || constantMessageData.FAILED_MESSAGE_GENERIC,
          ],
        })
      );
    }
  }, [runApiResult]);
  // handle after call service show success and error message
  React.useEffect(() => {
    if (
      customizeLetterMessage &&
      customizeLetterMessage.message === 'SUCCESS'
    ) {
      setWarningAlert(false);
      handleScrollToEvent();
      dispatch(
        setGenerateInvoiceDetailTab({
          ...detailScreenTabData,
          successMessages: [constantMessageData.SUCCESSMESSAGE_GENERIC],
          errorMessages: [],
        })
      );
      dispatch(dispatchGenerateInvoiceCriteriaList([]));
      handleRedirectInvoiceDetailScreen({ ...state });
    } else if (customizeLetterMessage === 'failed') {
      handleScrollToEvent();
      dispatch(
        setGenerateInvoiceDetailTab({
          ...detailScreenTabData,
          errorMessages: [constantMessageData.FAILED_MESSAGE_GENERIC],
          successMessages: [],
        })
      );
    }
  }, [customizeLetterMessage]);
  // handling Run Now functionality on click event
  const onSubmit = (field) => {
    let runVar = '';
    dispatch(
      setGenerateInvoiceDetailTab({
        ...detailScreenTabData,
        disabledSaveCancelBtn: false,
        successMessages: [],
        errorMessages: [],
      })
    );
    if (field === 'runNow') {
      runVar = 'N';
      setRunButton('N');
    } else {
      runVar = 'L';
      setRunButton('L');
    }
    if (generateInvoiceGridData && generateInvoiceGridData?.length > 0) {
      if (state.actionType === 0) {
        if (
          generateInvoiceGridData?.filter((x) => {
            return parseInt(x.defPaperInd, [0, 1]) === 1;
          }).length > 0
        ) {
          setOpenBeginPrinting(true);
          setBeginPrintingState('both');
          if (fetchState?.isResumePrinting) {
            dispatch(
              getPlanTypeCdUsingRebateProg({
                rebateProgramCd: generateInvoiceGridData?.filter((x) => {
                  return parseInt(x.defPaperInd, [0, 1]) === 1;
                })[0]?.rebateProgramCd,
              })
            );
          }
        } else {
          setWarningAlert(true);
          setWaringMessage(constantMessageData.NO_CHECKED_ANY_PRINT_PAPER);
        }
      }
      if (state.actionType === 1 || state.actionType === 2) {
        if (
          generateInvoiceGridData?.filter((x) => {
            return (
              parseInt(x.printImageInd, [0, 1]) === 1 ||
              parseInt(x.defCmsElectInd, [0, 1]) === 1 ||
              parseInt(x.defNcpdpSummaryInd, [0, 1]) === 1 ||
              parseInt(x.defNcpdpClaimOwnInd, [0, 1]) === 1 ||
              parseInt(x.defNcpdpClaimMbInd, [0, 1]) === 1
            );
          }).length > 0
        ) {
          if (runVar === 'N') {
            handleRunAPICall({
              runProcessOption: runVar,
              packageProcessVo: generateInvoiceGridData
                ?.filter((x) => {
                  return (
                    parseInt(x.printImageInd, [0, 1]) === 1 ||
                    parseInt(x.defCmsElectInd, [0, 1]) === 1 ||
                    parseInt(x.defNcpdpSummaryInd, [0, 1]) === 1 ||
                    parseInt(x.defNcpdpClaimOwnInd, [0, 1]) === 1 ||
                    parseInt(x.defNcpdpClaimMbInd, [0, 1]) === 1
                  );
                })
                ?.map((item) => {
                  const tempObj = [];
                  if (parseInt(item.printImageInd, [0, 1]) === 1) {
                    tempObj.push('Print Image');
                  }
                  if (parseInt(item.defCmsElectInd, [0, 1]) === 1) {
                    tempObj.push('CMS Elect');
                  }
                  if (parseInt(item.defNcpdpSummaryInd, [0, 1]) === 1) {
                    tempObj.push('Summary');
                  }
                  if (parseInt(item.defNcpdpClaimOwnInd, [0, 1]) === 1) {
                    tempObj.push('Claim Own');
                  }
                  if (parseInt(item.defNcpdpClaimMbInd, [0, 1]) === 1) {
                    tempObj.push('Claim MB');
                  }
                  return {
                    invoiceNum: item.invoiceNum,
                    formates: tempObj,
                    allFormatesWithCmsEleOption:
                      state.actionType === 2
                        ? false
                        : tempObj?.length > 1 &&
                          tempObj?.filter((x) => {
                            return x === 'CMS Elect';
                          })?.length > 0,
                    onlyCmsEleOption:
                      state.actionType === 2
                        ? false
                        : tempObj?.length === 1 &&
                          tempObj?.filter((x) => {
                            return x === 'CMS Elect';
                          })?.length > 0,
                  };
                }),
              userId: UserDefaultValues?.userId
                ? UserDefaultValues?.userId
                : logInUser,
              progCd: fetchState?.isResumePrinting
                ? generateInvoiceGridData?.filter((x) => {
                    return (
                      parseInt(x.printImageInd, [0, 1]) === 1 ||
                      parseInt(x.defCmsElectInd, [0, 1]) === 1 ||
                      parseInt(x.defNcpdpSummaryInd, [0, 1]) === 1 ||
                      parseInt(x.defNcpdpClaimOwnInd, [0, 1]) === 1 ||
                      parseInt(x.defNcpdpClaimMbInd, [0, 1]) === 1
                    );
                  })[0]?.rebateProgramCd
                : searchScreenTabObj?.state?.rebateProgramCd,
              action: state?.actionType,
              qtr: fetchState?.isResumePrinting
                ? generateInvoiceGridData?.filter((x) => {
                    return (
                      parseInt(x.printImageInd, [0, 1]) === 1 ||
                      parseInt(x.defCmsElectInd, [0, 1]) === 1 ||
                      parseInt(x.defNcpdpSummaryInd, [0, 1]) === 1 ||
                      parseInt(x.defNcpdpClaimOwnInd, [0, 1]) === 1 ||
                      parseInt(x.defNcpdpClaimMbInd, [0, 1]) === 1
                    );
                  })[0]?.qtr
                : fetchState?.quarterValue,
              planTypeCd: fetchState?.isResumePrinting
                ? fetchPlanTypeCd
                : fetchState?.planTypeCd,
            });
          }
          if (runVar === 'L') {
            setRunLaterPopup(true);
          }
        } else {
          setWarningAlert(true);
          setWaringMessage(
            state.actionType === 2
              ? constantMessageData.NO_CHECKED_ANY_UPLOAD_REBATE_WEB
              : constantMessageData.NO_CHECKED_ANY_CREATED_ELECTRONIC_FILE
          );
        }
      }
    } else {
      setWarningAlert(true);
      setWaringMessage(constantMessageData.NO_DATA_TO_DISPLAY);
    }
  };
  // handle Run now button click after call service and Print PDF.
  const buildPrintRequestObj = () => ({
    runProcessOption: 'N',
    invoiceNum: generateInvoiceGridData
      ?.filter((x) => {
        return parseInt(x.defPaperInd, [0, 1]) === 1;
      })
      .map((item) => {
        return item.invoiceNum;
      }),
    userId: UserDefaultValues?.userId ? UserDefaultValues?.userId : logInUser,
    action: state?.actionType,
    progCd: fetchState?.isResumePrinting
      ? generateInvoiceGridData?.filter((x) => {
          return parseInt(x.defPaperInd, [0, 1]) === 1;
        })[0]?.rebateProgramCd
      : searchScreenTabObj?.state?.rebateProgramCd,
    qtr: fetchState?.isResumePrinting
      ? generateInvoiceGridData?.filter((x) => {
          return parseInt(x.defPaperInd, [0, 1]) === 1;
        })[0]?.qtr
      : fetchState?.quarterValue,
    planTypeCd: fetchState?.isResumePrinting
      ? fetchPlanTypeCd
      : fetchState?.planTypeCd,
  });
  const buildFailedInvoiceRequest = (failedInvoice) => {
    const failedRequest = {
      invoicePrintListRequestVOs: [],
    };
    failedInvoice.forEach((item) => {
      const failedReq = {};
      failedReq.invoicePrintListID = {};
      failedReq.invoicePrintListID.userId = logInUser;
      failedReq.invoicePrintListID.invoiceNum = item;
      failedReq.invoicePrintListID.electInd = 0;
      const mfgID = generateInvoiceGridData
        ?.filter((x) => {
          return x.invoiceNum === item;
        })
        .map((ele) => {
          return ele.mfgId;
        });
      failedReq.sortKey = mfgID[0];
      failedReq.mfgId = mfgID[0];
      failedRequest.invoicePrintListRequestVOs.push(failedReq);
    });
    return failedRequest;
  };
  const handleRunAPICall = async (obj) => {
    const invoiceArray = [];
    if (state.actionType === 0) {
      generateInvoiceGridData
        .filter((x) => {
          return parseInt(x.defPaperInd, [0, 1]) === 1;
        })
        .forEach((elem) => {
          invoiceArray.push(elem.invoiceNum);
        });
      obj.invoiceNum = invoiceArray;
      dispatch(callRunApi(obj));
    } else {
      dispatch(callRunApi(obj));
    }
    if (state.actionType === 0) {
      const noOfRun = generateInvoiceGridData
        ?.filter((x) => {
          return parseInt(x.defPaperInd, [0, 1]) === 1;
        })
        .map((ele) => {
          return ele.invoiceNum;
        });

      const resultPDF = [];
      if (obj.runProcessOption === 'N') {
        const merger = new PDFMerger();
        const failedInvoice = [];
        const binaryString = atob(blankPDF.blankPdfbase64);
        const bytes = new Uint8Array(binaryString.length);
        for (let j = 0; j < binaryString.length; j++) {
          bytes[j] = binaryString.charCodeAt(j);
        }
        for (let i = 0; i < noOfRun.length; i++) {
          let result1 = [];
          const req = {
            invoiceNum: [noOfRun[i]],
            rebateProgramCd: obj.progCd !== '-1' ? obj.progCd : null,
            userId: obj.userId,
            printInvoiceAndMailingLabels:
              beginPrintingState === 'both' || false,
            printJustInvoices: beginPrintingState === 'printInvoices' || false,
            printJustMailingLabels:
              beginPrintingState === 'mailingLabels' || false,
            action: state?.actionType,
            qtr: fetchState?.isResumePrinting
              ? generateInvoiceGridData?.filter((x) => {
                  return parseInt(x.defPaperInd, [0, 1]) === 1;
                })[0]?.qtr
              : fetchState?.quarterValue,
            planTypeCd: fetchState?.isResumePrinting
              ? fetchPlanTypeCd
              : fetchState?.planTypeCd,
          };
          result1 = await dispatch(getPrintPreview(req));
          if (result1) {
            if (state?.actionType === 0 && i + 1 === noOfRun.length) {
              dispatch(
                setGenerateInvoiceDetailTab({
                  ...detailScreenTabData,
                  successMessages: [AppConstants.INVOICE_JOB_COMPLETE],
                  errorMessages: [],
                })
              );
            }
            resultPDF.push(result1.pdfPrev);
            const myURL = window.URL || window.webkitURL;
            const file = new Blob([result1.pdfPrev], {
              type: 'application/pdf',
            });
            const fileURL = myURL.createObjectURL(file);
            const myURL1 = window.URL || window.webkitURL;
            const blankPdf = new Blob([bytes.buffer], {
              type: 'application/pdf',
            });
            const blankURL = myURL1.createObjectURL(blankPdf);
            await merger.add(fileURL);
            if (noOfRun?.length - 1 !== i) {
              await merger.add(blankURL);
            }
          } else if (result1 === undefined) {
            failedInvoice.push(noOfRun[i]);
          }
        }

        const failedRequest = buildFailedInvoiceRequest(failedInvoice);
        if (failedInvoice?.length === 1) {
          const errorMsg = `${AppConstants.NO_DATA_TO_PRINT} ${failedInvoice[0]}.`;
          dispatch(
            setGenerateInvoiceDetailTab({
              ...detailScreenTabData,
              successMessages: [],
              errorMessages: [errorMsg],
            })
          );
        } else if (failedInvoice?.length > 1) {
          const errorMsg = `${
            AppConstants.NO_DATA_TO_PRINT
          } ${failedInvoice?.map((item) => {
            return item;
          })}.`;
          dispatch(
            setGenerateInvoiceDetailTab({
              ...detailScreenTabData,
              successMessages: [],
              errorMessages: [errorMsg],
            })
          );
        }
        if (merger.doc !== undefined) {
          const mergedPdfBuffer = await merger.saveAsBuffer();
          const myprintURL = window.URL || window.webkitURL;
          const printfile = new Blob([mergedPdfBuffer], {
            type: 'application/pdf',
          });
          const filePrintURL = myprintURL.createObjectURL(printfile);
          printJS({
            printable: filePrintURL,
            type: 'pdf',
            onPrintDialogClose: () => {
              dispatch(saveFailedInvoice(failedRequest));
            },
          });
        } else {
          dispatch(saveFailedInvoice(failedRequest));
        }
      }
    }
  };
  // call API service after click on run later button
  const handleRunOnLater = () => {
    setRunLaterPopup(false);
    dispatch(
      setGenerateInvoiceDetailTab({
        ...detailScreenTabData,
        disabledSaveCancelBtn: false,
        successMessages: [],
        errorMessages: [],
      })
    );
    handleRunAPICall({
      runProcessOption: 'L',
      packageProcessVo: generateInvoiceGridData
        ?.filter((x) => {
          return (
            parseInt(x.printImageInd, [0, 1]) === 1 ||
            parseInt(x.defCmsElectInd, [0, 1]) === 1 ||
            parseInt(x.defNcpdpSummaryInd, [0, 1]) === 1 ||
            parseInt(x.defNcpdpClaimOwnInd, [0, 1]) === 1 ||
            parseInt(x.defNcpdpClaimMbInd, [0, 1]) === 1
          );
        })
        ?.map((item) => {
          const tempObj = [];
          if (parseInt(item.printImageInd, [0, 1]) === 1) {
            tempObj.push('Print Image');
          }
          if (parseInt(item.defCmsElectInd, [0, 1]) === 1) {
            tempObj.push('CMS Elect');
          }
          if (parseInt(item.defNcpdpSummaryInd, [0, 1]) === 1) {
            tempObj.push('Summary');
          }
          if (parseInt(item.defNcpdpClaimOwnInd, [0, 1]) === 1) {
            tempObj.push('Claim Own');
          }
          if (parseInt(item.defNcpdpClaimMbInd, [0, 1]) === 1) {
            tempObj.push('Claim MB');
          }
          return {
            invoiceNum: item.invoiceNum,
            formates: tempObj,
            allFormatesWithCmsEleOption:
              state.actionType === 2
                ? false
                : tempObj?.length > 1 &&
                  tempObj?.filter((x) => {
                    return x === 'CMS Elect';
                  })?.length > 0,
            onlyCmsEleOption:
              state.actionType === 2
                ? false
                : tempObj?.length === 1 &&
                  tempObj?.filter((x) => {
                    return x === 'CMS Elect';
                  })?.length > 0,
          };
        }),
      userId: UserDefaultValues?.userId ? UserDefaultValues?.userId : logInUser,
      progCd: fetchState?.isResumePrinting
        ? generateInvoiceGridData?.filter((x) => {
            return (
              parseInt(x.printImageInd, [0, 1]) === 1 ||
              parseInt(x.defCmsElectInd, [0, 1]) === 1 ||
              parseInt(x.defNcpdpSummaryInd, [0, 1]) === 1 ||
              parseInt(x.defNcpdpClaimOwnInd, [0, 1]) === 1 ||
              parseInt(x.defNcpdpClaimMbInd, [0, 1]) === 1
            );
          })[0]?.rebateProgramCd
        : searchScreenTabObj?.state?.rebateProgramCd,
      action: state?.actionType,
      qtr: fetchState?.isResumePrinting
        ? generateInvoiceGridData?.filter((x) => {
            return (
              parseInt(x.printImageInd, [0, 1]) === 1 ||
              parseInt(x.defCmsElectInd, [0, 1]) === 1 ||
              parseInt(x.defNcpdpSummaryInd, [0, 1]) === 1 ||
              parseInt(x.defNcpdpClaimOwnInd, [0, 1]) === 1 ||
              parseInt(x.defNcpdpClaimMbInd, [0, 1]) === 1
            );
          })[0]?.qtr
        : fetchState?.quarterValue,
      planTypeCd: fetchState?.isResumePrinting
        ? fetchPlanTypeCd
        : fetchState?.planTypeCd,
    });
  };
  // customize Letter call API service on click event
  const handleUpdateFreeFromText = () => {
    if (freeFromTextValue !== '') {
      setErrorMessages(null);
      setCustomizeLetterPopup(false);
      dispatch(
        postUpdateCustomizeLetter({
          freeFormText: freeFromTextValue,
          invoiceNum: invoiceNum,
          userId: UserDefaultValues?.userId
            ? UserDefaultValues?.userId
            : logInUser,
        })
      );
    } else {
      setErrorMessages(constantMessageData.COMMENT_REQUIRED);
    }
  };
    // handle On change  set values on filed level
 const handleOnChangeEvent = (value, name) => {
  let newObj = { ...state, [name]: value };

  if (name === 'actionType') {
    switch (value) {
      case 0:
        newObj = {
          ...state,
          [name]: value,
          includeCreated: 0,
          includeNonRequested: 0,
          includeUploaded: 0,
          includePrinted: 1,
          includeMailed: 0,
          includeNotCreated: 0,
        };
        break;
      case 1:
        newObj = {
          ...state,
          [name]: value,
          includeCreated: 1,
          includeNonRequested: 0,
          includeUploaded: 0,
          includePrinted: 0,
          includeMailed: 0,
          includeNotCreated: 0,
        };
        break;
      case 2:
        newObj = {
          ...state,
          [name]: value,
          includeCreated: 0,
          includeNonRequested: 0,
          includeUploaded: 0,
          includePrinted: 0,
          includeMailed: 0,
          includeNotCreated: 1,
        };
        break;
      default:
        break;
    }
  }
  setState(newObj);
  dispatch(
    setGenerateInvoiceDetailTab({
      ...detailScreenTabData,
      disabledSaveCancelBtn: true,
      successMessages: [],
      errorMessages: [],
      state: newObj,
    })
  );

  handleRedirectInvoiceDetailScreen(newObj);
};
  // call on click event radio filed level
  const handelCheckEvent = (e, name) => {
  const newObj = { ...state, [name]: e.target.checked ? 1 : 0 };
  dispatch(
    setGenerateInvoiceDetailTab({
      ...detailScreenTabData,
      disabledSaveCancelBtn: false,
      successMessages: [],
      errorMessages: [],
      state: newObj,
    })
  );

  setState(newObj);
  setRedirection(true);
};
  
  React.useEffect(()=>{
    if(redirectionState){
      handleRedirectInvoiceDetailScreen(state)
      setRedirection(false)
    }
  },[redirectionState,state])
  // handing reset All fields & data
  const resetAllFields = () => {
    const tempObj = generateInvoiceGridData; 
    if (tempObj && tempObj?.length > 0) {
      if (state.actionType === 0) {
        tempObj.map((item) => {
          item.defPaperInd = 0;
          return item;
        });
      } else if (state.actionType === 1 || state.actionType === 2) {
        tempObj.map((item) => {
          item.printImageInd = 0;
          item.defCmsElectInd = 0;
          item.defNcpdpSummaryInd = 0;
          item.defNcpdpClaimMbInd = 0;
          item.defNcpdpClaimOwnInd = 0;
          return item;
        });
      }
      if (gridParams?.api) {
        gridParams.api.refreshCells();
      }
      dispatch(dispatchGenerateInvoiceCriteriaList(tempObj));
    }
  };
  const clearMessageState = ()=>{
    dispatch(
      setGenerateInvoiceDetailTab({
        ...detailScreenTabData,
        successMessages: [],
        errorMessages: [],
      })
    );
  }
    // redirect Go to Customize Letter Popup
  const handleGoToCustomizeLetter = (row) => {
    dispatch(
      setGenerateInvoiceDetailTab({
        ...detailScreenTabData,
        successMessages: [],
        errorMessages: [],
        
      })
    );
    setInvoiceNum(row?.invoiceNum);
    setCustomizeLetterPopup(true);
  };
    // redirect Go to Invoice Reports Details page
  const handleGoToInvoice = (row) => {
    if (row) {
      const obj = {
        rebateProgram: row?.rebateProgramCd,
        templateTypes: ['COLLECT', 'COVER', 'DISPUTE'],
        isSelectedByProQtrManu: true,
      };
      setRedirect(true);
      dispatch(getInvoiceLetterTableData(obj));
      dispatch(
        getPrintCover({
          invoiceNum: [row?.invoiceNum],
          rebateProgramCd: row?.rebateProgramCd,
          userId: UserDefaultValues?.userId,
          duplicate: 'false',
        })
      );
      dispatch(getInvoiceDetailsByInvoiceNum({ invoiceNum: row?.invoiceNum }));
    }
  };
  // go to particular Contract action button handler function
  const handleGoToContract = (row) => {
    dispatch(dispatchCellClick(true));
    dispatch(selectedType('C'));
    searchContractState.contractType = 'onSelect';
    searchContractState.selectedContractType = 'contractId';
    searchContractState.selectedRowData = row?.contractSeqNum;
    searchContractState.selectedContractId = row?.contractSeqNum;
    searchContractState.rebateProgramCode = row?.rebateProgramCd;
    redirectURLLink('/createContract', 'Maintain Contract', history, dispatch);
  };
  // go to particular manufacturer action button handler function
  const handleGoToManufacturer = (row) => {
    dispatch(setSelectManufacturerData({}));
    dispatch(fetchAllManufacturerDetail(null));
    dispatch(getContactDetails(null));
    dispatch(maintainLabelerListData({}));
    dispatch(setMaintainManufacturerTab({}));
    dispatch(
      setSelectManufacturerData({
        mfgId: row?.mfgId,
        mfgTypeCd: 'C',
        updateManufacturer: true,
      })
    );
    redirectURLLink(
      '/manufacturer-detail',
      'Maintain Manufacturer',
      history,
      dispatch
    );
  };
  // redirect To rebate program screen
  React.useEffect(() => {
    if (rebateProgramDetailData && rebateProgramDetailData.status === '001') {
      if (callRedirectRebateProgram) {
        localStorage.setItem('viewpgmdetails', 'true');
        redirectURLLink(
          '/maintainRebate',
          'Maintain Rebate Program',
          history,
          dispatch
        );
        setCallRedirectRebateProgram(false);
      }
    }
  }, [rebateProgramDetailData]);
  // go to particular Rebate Program action button handler function
  const handleGoToRebateProgram = (row, stateData) => {
    dispatch(
      getRebatePgmDetail({
        planType: stateData?.planTypeCd,
        rebateProg: row?.rebateProgramCd,
      })
    );
    setCallRedirectRebateProgram(true);
  };
  const handleGenerateLocalPrint = () => {
    handleRunAPICall(buildPrintRequestObj());
  };
  const handleRemotePrint = async (printerIpAddrs) => {
    if (!printerIpAddrs || printerIpAddrs === '-1') {
      dispatch(
        setGenerateInvoiceDetailTab({
          ...detailScreenTabData,
          successMessages: [],
          errorMessages: [constantMessageData.NO_PRINTER_AVAILABLE_ERROR],
        })
      );
      resetAllFields();
      return;
    }

    const printObj = buildPrintRequestObj();
    const invoiceArray = printObj.invoiceNum || [];

    dispatch(
      callRunApi({
        ...printObj,
        invoiceNum: invoiceArray,
      })
    );

    const remotePrintResult = await dispatch(
      remotePrintInvoice({
        printerIpAddrs,
        invoiceNum: invoiceArray,
        rebateProgramCd: printObj.progCd !== '-1' ? printObj.progCd : null,
        userId: printObj.userId,
        quarter: printObj.qtr,
        planTypeCd: printObj.planTypeCd,
        printInvoiceAndMailingLabels: beginPrintingState === 'both' || false,
        printJustInvoices: beginPrintingState === 'printInvoices' || false,
        printJustMailingLabels: beginPrintingState === 'mailingLabels' || false,
      })
    );

    const failedInvoice = remotePrintResult?.failedInvoiceNums || [];
    const errorMessages = [];

    if (failedInvoice?.length === 1) {
      errorMessages.push(
        `${AppConstants.NO_DATA_TO_PRINT} ${failedInvoice[0]}.`
      );
    } else if (failedInvoice?.length > 1) {
      errorMessages.push(
        `${AppConstants.NO_DATA_TO_PRINT} ${failedInvoice?.map((item) => {
          return item;
        })}.`
      );
    }

    if (failedInvoice?.length > 0) {
      dispatch(saveFailedInvoice(buildFailedInvoiceRequest(failedInvoice)));
    }

    if (remotePrintResult?.status === '001') {
      dispatch(
        setGenerateInvoiceDetailTab({
          ...detailScreenTabData,
          successMessages: [AppConstants.INVOICE_JOB_COMPLETE],
          errorMessages,
        })
      );
    } else {
      dispatch(
        setGenerateInvoiceDetailTab({
          ...detailScreenTabData,
          successMessages: [],
          errorMessages:
            errorMessages.length > 0
              ? errorMessages
              : [
                  remotePrintResult?.message ||
                    constantMessageData.REMOTE_PRINT_FAILED_ERROR,
                ],
        })
      );
    }
  };

  React.useEffect(() => {
    const checkAndSetAttributes = () => {
      const hiddenTextarea = document.querySelector(
        'textarea[aria-hidden="true"]'
      );
      if (hiddenTextarea) {
        hiddenTextarea.setAttribute('id', 'hiddenTextArea');
        // Optionally, you can add an aria-labelledby to link it with a label
        // hiddenTextarea.setAttribute('aria-labelledby', 'hiddenLabel');
        return true;
      }
      return false;
    };
    // Try to set the attributes every 100ms, for up to 1 second
    const intervalId = setInterval(() => {
      if (checkAndSetAttributes()) {
        clearInterval(intervalId); // Stop checking once the element is found
      }
    }, 100);
    return () => clearInterval(intervalId);
  }, []);
React.useEffect(()=>{
  clearMessageState()
},[rebateProgramDetailData])
  return (
    <div
      className='tBillPanel custom-check'
      data-testid='generate-invoice-details-component'
    >
      <div className='panel tBillPanel-space devider-line pb-0'>
        <CustomSeparator parent1='Invoice' parent2='Generate Invoice Detail' />
        {!fullScreenView && (
          <>
            <DisplayErrorMessages
              errorMessages={[
                ...new Set(
                  detailScreenTabData?.errorMessages?.length > 0
                    ? _.map(detailScreenTabData?.errorMessages, (l) => l)
                    : []
                ),
              ]}
              addInLineCss
            />
            <DisplaySuccessMessages
              successMessages={
                detailScreenTabData?.successMessages?.length > 0
                  ? [...new Set(detailScreenTabData?.successMessages)]
                  : []
              }
            />
          </>
        )}
        <Spinner load={spinnerLoader} />
        {!fullScreenView && (
          <div className='clearfix'>
            <div className='float-right btn-wrapper pt-4'>
              <div className=' display-inline-flex'>
                <div className='float-right'>
                  <Button
                    id='name-filter-btn-id'
                    title='Run Now'
                    data-testid='run-Now-btn'
                    className='btn btn-success btn-search ml-1 float-right'
                    disabled={state?.includePrinted===0&&state?.includeMailed===0&&state?.includeNonRequested===0&&state?.includeNotCreated==0&&state?.includeCreated==0&&state?.includeUploaded==0}
                    onClick={() => onSubmit('runNow')}
                  >
                    <SVGComponent iconName='Icon-run-now' /> {'  '} Run Now
                  </Button>
                  <Button
                    id='name-filter-btn-id'
                    title='clear All'
                    data-testid='clear-all-btn'
                    className='btn btn-success btn-search ml-1 float-right'
                    onClick={() =>{ 
                      clearMessageState()
                      resetAllFields()}}
                  >
                    <SVGComponent iconName='Icon-cancel' /> {'  '} Clear All
                  </Button>
                </div>
                <div>
                  <Button
                    id='name-filter-btn-id'
                    title='Run Later'
                    data-testid='run-Later-btn'
                    className='btn btn-success btn-search ml-1 float-right'
                    disabled={state.actionType === 0}
                    onClick={() => onSubmit('runLater')}
                  >
                    <SVGComponent iconName='Icon-run-later' /> {'  '} Run Later
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
        {!fullScreenView && (
          <>
            <div className='panel mb-3 mt-sm-2'>
              <div className='row'>
                <div className='col-12 mt-3 col-sm-12 mt-sm-0 col-md-6 col-lg-6 col-xl-4'>
                  <RadioGroupComponent
                    data-testid='action-to-perform'
                    id='filter-plan-by-radio-btn-action'
                    labelName='Action to Perform'
                    required
                    reqColor
                    optionList={[
                      {
                        name: 'Create Electronic Files',
                        value: 1,
                        disabled: fetchState?.isResumePrinting,
                      },
                      {
                        name: 'Upload to Rebate Web',
                        value: 2,
                        disabled: fetchState?.isResumePrinting,
                      },
                      {
                        name: 'Print Paper Invoices',
                        value: 0,
                        disabled: fetchState?.isResumePrinting,
                      },
                    ]}
                    disabled={fetchState?.isResumePrinting}
                    defaultValue={state && state.actionType}
                    filterAction={(e) => {
                      clearMessageState()
                      dispatch(dispatchGenerateInvoiceCriteriaList([]));
                      handleOnChangeEvent(e, 'actionType');
                    }}
                    className='log-batch-filter-radio frr-checkInvoiceRadio'
                  />
                </div>
                <div className='col-12 mt-3 col-sm-12 mt-sm-3 col-md-6 mt-md-0 col-lg-6 col-xl-4'>
                  <fieldset className='custom-fieldset'>
                    <legend className='same-font-family'>
                      {fetchState?.isResumePrinting ? (
                        <>
                          Select the invoice on which printing <br />
                          will resume, then 'run now'
                        </>
                      ) : (
                        <>
                          Please select the Invoices /<br />
                          Formats that you want to include
                        </>
                      )}
                    </legend>
                    <div className='form-wrapper p-0 mt-2'>
                      <div className='mui-custom-form input-md field-xl'>
                        <div className='form-wrapper db'>
                          {state.actionType === 1 && (
                            <FormControlLabel
                              className='ml-0'
                              data-testid='includeCreated'
                              control={
                                <Checkbox color='primary' className='mr-2' />
                              }
                              label='Include Created'
                              checked={state.includeCreated === 1}
                              value={state.includeCreated === 1}
                              onChange={(e) => {
                                handelCheckEvent(e, 'includeCreated');
                              }}
                            />
                          )}
                          {state.actionType === 2 && (
                            <FormControlLabel
                              className='ml-0'
                              data-testid='includeNotCreated'
                              control={
                                <Checkbox color='primary' className='mr-2' />
                              }
                              label='Include Not-Created'
                              checked={state.includeNotCreated === 1}
                              value={state.includeNotCreated === 1}
                              onChange={(e) => {  
                                handelCheckEvent(e, 'includeNotCreated');
                              }}
                            />
                          )}
                          {state.actionType === 0 && (
                            <FormControlLabel
                              className='ml-0'
                              data-testid='includePrinted'
                              control={
                                <Checkbox color='primary' className='mr-2' />
                              }
                              label='Include Printed'
                              disabled={fetchState?.isResumePrinting}
                              checked={state.includePrinted === 1}
                              value={state.includePrinted === 1}
                              onChange={(e) => {                      
                                handelCheckEvent(e, 'includePrinted');
                              }}
                            />
                          )}
                          <FormControlLabel
                            className='ml-0'
                            data-testid='checked_inr'
                            control={
                              <Checkbox color='primary' className='mr-2' />
                            }
                            label='Include Non-Requested'
                            disabled={fetchState?.isResumePrinting}
                            checked={state.includeNonRequested === 1}
                            value={state.includeNonRequested === 1}
                            onChange={(e) => {
                              handelCheckEvent(e, 'includeNonRequested');
                            }}
                          />
                          {state.actionType === 0 && (
                            <FormControlLabel
                              className='ml-0'
                              data-testid='checked_im'
                              control={
                                <Checkbox color='primary' className='mr-2' />
                              }
                              label='Include Mailed'
                              disabled={fetchState?.isResumePrinting}
                              checked={state.includeMailed === 1}
                              value={state.includeMailed === 1}
                              onChange={(e) => {
                                handelCheckEvent(e, 'includeMailed');
                              }}
                            />
                          )}
                          {state.actionType !== 0 && (
                            <FormControlLabel
                              className='ml-0'
                              data-testid='checked_im'
                              control={
                                <Checkbox color='primary' className='mr-2' />
                              }
                              label='Include Uploaded'
                              checked={state.includeUploaded === 1}
                              value={state.includeUploaded === 1}
                              onChange={(e) => {
                                handelCheckEvent(e, 'includeUploaded');
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div className='col-12 mt-3 col-sm-12 mt-sm-3 col-md-12 mt-md-0 col-lg-12 col-xl-4'>
                  <fieldset className='custom-fieldset mt-2 frr-height-153'>
                    <div className='form-wrapper db legend-section mt-2'>
                      <label>
                        <span className='legend-box blue-legend' />
                        <span>
                          {' '}
                          Electronic Files Created And Not Distributed{' '}
                        </span>{' '}
                      </label>
                      <label>
                        <span className='legend-box yellow-legend' />
                        <span>Not Requested And Not Distributed</span>
                      </label>
                      <label>
                        <span className='legend-box pink-legend' />
                        <span>
                          Already{' '}
                          {state.actionType === 0 ? 'Mailed' : 'Uploaded'}{' '}
                        </span>
                      </label>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </>
        )}
        <div className='panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk frr-invoiceThreshold frr-aggrid-ckekbox-invoice'>
          <TableGrid
            ref={gridRef}
            gridHeight={fullScreenView ? '70vh' : tableGridHight350}
            rowData={
              state?.includeCreated === 1 ||
              state?.includeNonRequested === 1 ||
              state?.includeUploaded === 1 ||
              state?.includePrinted === 1 ||
              state?.includeMailed === 1 ||
              state?.includeNotCreated === 1
                ? generateInvoiceGridData
                : []
            }
            columnDefs={columnDefs?.filter((x) => {
              if (state.actionType === 0) {
                return (
                  x.field !== 'printImageInd' &&
                  x.field !== 'defCmsElectInd' &&
                  x.field !== 'defNcpdpSummaryInd' &&
                  x.field !== 'defNcpdpClaimOwnInd' &&
                  x.field !== 'defNcpdpClaimMbInd'
                );
              }
              if (state.actionType === 1 || state.actionType === 2) {
                return x.field !== 'defPaperInd';
              }
              return x;
            })}
            fullScreenView={fullScreenView}
            gridCall={onGridReady}
            handleFullScreenViewClick={handleFullScreenView}
            exportFile
            helpMessage=''
            data-testid='generate-invoice-grid'
            fileName='Generate Invoices'
            hideColumnsInPdf={
              state.actionType === 0
                ? [
                    'action',
                    'defPaperColor',
                    'printImageInd',
                    'defCmsElectInd',
                    'defNcpdpSummaryInd',
                    'defNcpdpClaimOwnInd',
                    'defNcpdpClaimMbInd',
                  ]
                : ['action', 'defPaperInd', 'defPaperColor']
            }
            singleClickEdit
            suppressCellFocus
           // isScrollOn
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            enterMovesDown
            onCellFocused={onCellFocused}
            frameworkComponents={{
              ActionCellRender: (cellInfo) => {
     
  const gridContainer = document.querySelector('.ag-root'); 

                const detailScreenTabObj = useSelector(
                  (reduxState) =>
                    reduxState.sharedState.GenerateInvoiceReducer
                      ?.generateInvDetailTabObj
                );
                const fetchStateData = useSelector(
                  (reduxState) =>
                    reduxState.sharedState.GenerateInvoiceReducer
                      ?.perviousSearchScreenDataRedux?.state
                );
                return (
                  <div
                    className='tdCell icon-btn-group'
                    data-testid='action-column'
                  >
                    <Dropdown className="icon-dropdown-container">
        <Dropdown.Toggle
          className="icon-dropdown export_wrap"
          aria-label="export"
        >
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="action-tooltip">Actions</Tooltip>}
          >
            <SVGComponent iconName="Icon-export1" />
          </OverlayTrigger>
        </Dropdown.Toggle>
  
        <Dropdown.Menu
          renderMenuOnMount
          className="export_dropdown"
          popperConfig={{
            strategy: 'absolute',
            placement: 'bottom-start', 
            modifiers: [
              {
                name: 'flip',
                options: {
                  fallbackPlacements: ['top-start', 'right-start', 'bottom-start'],
                  boundary: gridContainer,
                  padding: 8,
                },
              },
              {
                name: 'preventOverflow',
                options: {
                  boundary: gridContainer, 
                  padding: 8,
                },
              },
              {
                name: 'offset',
                options: {
                  offset: [0, 8], 
                },
              },
            ],
          }}
        >
                        {detailScreenTabObj?.state?.actionType == 1 && (
                          <Dropdown.Item
                            role='button'
                            onClick={() => {
                             // clearMessageState()
                              handleGoToCustomizeLetter(cellInfo?.data);
                              setFreeFromTextValue('');
                            }}
                          >
                            Customize Letter
                          </Dropdown.Item>
                        )}
                        <Dropdown.Item
                          role='button'
                          onClick={() =>{ 
                          //  clearMessageState()
                            handleGoToInvoice(cellInfo?.data)}}
                        >
                          Go to Invoice
                        </Dropdown.Item>
                        <Dropdown.Item
                          role='button'
                          onClick={() => {
                            //clearMessageState()
                            handleGoToContract(cellInfo?.data)}}
                        >
                          Go to Contract
                        </Dropdown.Item>
                        <Dropdown.Item
                          role='button'
                          onClick={() => {
                           // clearMessageState()
                            handleGoToManufacturer(cellInfo?.data)}}
                        >
                          Go to Manufacturer
                        </Dropdown.Item>
                        <Dropdown.Item
                          role='button'
                          onClick={() =>
                          { 
                            //clearMessageState() 
                            handleGoToRebateProgram(
                              cellInfo?.data,
                              fetchStateData
                            )}
                          }
                        >
                          Go to Rebate Program
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                );
              },
              PrintImageIndCheckBoxRender: CheckBoxRender,
              DefPaperIndCheckBoxRender: CheckBoxRender,
              DefCmsElectIndCheckBoxRender: CheckBoxRender,
              DefNcpdpSummaryIndCheckBoxRender: CheckBoxRender,
              DefNcpdpClaimOwnIndCheckBoxRender: CheckBoxRender,
              DefNcpdpClaimMbIndCheckBoxRender: CheckBoxRender,
              InvoiceNumberRender: (cellInfo) => {
                const name = cellInfo.data.invoiceNum;
                if (name && name.length > 24) {
                  return (
                    <OverlayTrigger
                      placement='bottom'
                      overlay={<Tooltip id='name-tooltip'>{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
          />
        </div>
      </div>
      <CommonModal
        open={openBeginPrinting}
        className='dialogPanel custom-check dialog-420'
        data-testid='common-modal-begin-printing'
        viewAction
        viewHeader
        modalTitle='Begin Printing'
        okTitle='Ok'
        closeTitle='Cancel'
        removeClassName
        childrenComponent={
          <>
            <div className='col-12'>
              <div className='mb-2 font-weight-bold'>
                You have chosen{' '}
                {
                  generateInvoiceGridData?.filter((x) => {
                    return parseInt(x.defPaperInd, [0, 1]) === 1;
                  }).length
                }{' '}
                invoice to process.
                <br />
                How would you like to proceed?
              </div>
              <FormControl>
                <RadioGroup
                  row
                  defaultValue={beginPrintingState}
                  value={beginPrintingState}
                  data-testid='radio-box-group-control'
                >
                  {beginPrintingOptionList?.map((v) => (
                    <FormControlLabel
                      value={v.value}
                      control={
                        <Radio
                          onChange={() => setBeginPrintingState(v.value)}
                          data-testid='radio-box-change'
                        />
                      }
                      disabled={v.disabled ? v.disabled : false}
                      label={v.name}
                      key={v.value && _.kebabCase(v.value)}
                      data-testid='radio-box-change-control'
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </div>
          </>
        }
        onOk={() => {
          clearMessageState()
          setOpenBeginPrinting(false);
          if (beginPrintingState !== 'mailingLabels') {
            setShowPrinterOption(true);
          } else {
            handleGenerateLocalPrint();
          }
        }}
        onClose={() => setOpenBeginPrinting(false)}
      />
      <CommonModal
        open={showPrinterOption}
        className='dialogPanel custom-check dialog-420'
        data-testid='common-modal-begin-printing'
        viewAction
        viewHeader
        modalTitle='Printer Selection'
        okTitle='Ok'
        closeTitle='Cancel'
        removeClassName
        childrenComponent={
          <>
            <div className='col-12'>
              <div className='mb-2 font-weight-bold'>
                Please Select any one option:
              </div>
              <FormControl>
                <RadioGroup
                  row
                  defaultValue={selectPrinterOption}
                  value={selectPrinterOption}
                  data-testid='radio-box-group-control'
                >
                  {remotePrinterOptions?.map((v) => (
                    <FormControlLabel
                      value={v.value}
                      control={
                        <Radio
                          onChange={() => handlePrinterOptionChange(v.value)}
                          data-testid='radio-box-change'
                        />
                      }
                      disabled={v.disabled ? v.disabled : false}
                      label={v.name}
                      key={v.value && _.kebabCase(v.value)}
                      data-testid='radio-box-change-control'
                    />
                  ))}
                </RadioGroup>
              </FormControl>
              {selectPrinterOption === 'remotePrinting' && (
                <div className='row mt-3'>
                  <div className='col-12'>
                    <fieldset className='custom-fieldset'>
                      <legend
                        className='same-font-family'
                        id='remotePrinterGroupLabel'
                      >
                        Remote Printer Selection
                      </legend>
                      <div className='form-wrapper p-0'>
                        <div className='mui-custom-form with-select field-xl no-lbl'>
                          <TextField
                            id='generate-invoice-remote-printer'
                            fullWidth
                            select
                            placeholder=''
                            inputProps={{
                              maxlength: 11,
                              'aria-labelledby': 'remotePrinterGroupLabel',
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={selectedRemotePrinterIp}
                            onChange={(e) =>
                              setSelectedRemotePrinterIp(e.target.value)
                            }
                            data-testid='remote-printer-select'
                          >
                            <MenuItem
                              key=''
                              value=''
                              className='frr-dropdown-blank-item'
                            />
                            {remotePrinterIpAddrList?.length > 0
                              ? remotePrinterIpAddrList.map((item, index) => (
                                  <MenuItem
                                    key={index}
                                    value={item.value}
                                    className='frr-logcheck-dropdown-item'
                                  >
                                    {item.label}
                                  </MenuItem>
                                ))
                              : null}
                          </TextField>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              )}
            </div>
          </>
        }
        onOk={() => {
          clearMessageState();
          setShowPrinterOption(false);
          if (selectPrinterOption === 'remotePrinting') {
            handleRemotePrint(selectedRemotePrinterIp);
          } else {
            handleGenerateLocalPrint();
          }
        }}
        onClose={() => {
          setShowPrinterOption(false);
          setSelectPrinterOption('localPrinting');
        }}
      />
      <div className='frr-rem-dialog-container-pt'>
        <CommonModal
          open={customizeLetterPopup}
          viewAction
          viewHeader
          okTitle='Ok'
          onOk={() => handleUpdateFreeFromText()}
          className='dialog-420'
          data-testid='common-popup-customizeLetter'
          onClose={() => {
            setFreeFromTextValue('');
            setCustomizeLetterPopup(false);
            setErrorMessages(null);
          }}
          closeTitle='Cancel'
          modalTitle='Customize Letter'
          childrenComponent={
            <div className='col-12 fieldset-customization pl-auto px-md-auto'>
              {errorMessages && (
                <DisplayErrorMessages errorMessages={[errorMessages]} />
              )}
              <label className='hide-elm' htmlFor='hiddenTextArea'>
                Comments
              </label>
              <legend className='same-font-family mx-0 frr-legend-font d-flex'>
                <span>Comments </span> <span className='mandatory'> *</span>
              </legend>
              <TextField
                id='comments-field-system'
                label='Comments'
                data-testid='comment-test'
                multiline
                autoFocus
                rows={2}
                rowsMax={10}
                onChange={(e) => setFreeFromTextValue(e.target.value)}
                defaultValue={freeFromTextValue}
                required
                className={
                  errorMessages
                    ? 'mandate-fields custom-textarea frr-display-hidden-label'
                    : 'custom-textarea frr-display-hidden-label'
                }
                inputProps={{ maxLength: 2000, id: 'comments-field-system' }}
                helperText={errorMessages}
                error={errorMessages}
                InputLabelProps={{
                  shrink: false,
                }}
              />
            </div>
          }
        />
      </div>
      <CommonModal
        className='dialog-420'
        data-testid='common-modal-generate-invoice'
        open={runLaterPopup}
        viewAction
        viewHeader
        onOk={() => handleRunOnLater()}
        onClose={() => setRunLaterPopup(false)}
        closeTitle='Cancel'
        okTitle='Ok'
        modalTitle='Generate Invoice Detail'
        childrenComponent={
          <div className='p-3'>
            You have requested at least one print image - these must be created
            now. Continue?
          </div>
        }
      />
      <CommonModal
        className='dialog-420'
        data-testid='common-modal-progress-bar'
        open={progressBarPopup}
        viewAction
        viewHeader
        onClose={() => {
          setProgressBarPopup(false);
        }}
        closeTitle='Cancel'
        modalTitle='Please Wait'
        childrenComponent={
          <div className='p-3'>
            <div className='col-12'>
              <div>Printing Invoices </div>
            </div>
          </div>
        }
      />
      <CommonModal
        className='dialog-420'
        data-testid='common-modal-warning'
        open={warningAlert}
        viewAction
        viewHeader
        onOk={() => {
          setWarningAlert(false);
          dispatch(dispatchUpdateCustomizeLetter(''));
        }}
        onClose={() => {
          setWarningAlert(false);
          dispatch(dispatchUpdateCustomizeLetter(''));
        }}
        okTitle='Ok'
        modalTitle='Generate Invoice Detail'
        childrenComponent={<div className='p-3'>{warningMessage}</div>}
      />
    </div>
  );
}
export default GenerateInvoiceDetailsCom;
